// lib/auth/validation.ts
import { z } from "zod";

// Mirrors the dashboard's signInSchema (zod v3 syntax — this repo is on zod 3.25).
export const signInSchema = z.object({
  email: z
    .string({ required_error: "Email là bắt buộc" })
    .email("Email không hợp lệ"),
  password: z
    .string({ required_error: "Mật khẩu là bắt buộc" })
    .min(8, "Mật khẩu phải có ít nhất 8 ký tự"),
});

export type SignInInput = z.infer<typeof signInSchema>;
